import { useAuth } from '@/features/auth/components/AuthListener'
import { useEffect } from 'react'
import { syncService } from './SyncService'

export const SyncProvider = ({ children }: { children: React.ReactNode }) => {
    const { user } = useAuth()

    useEffect(() => {
        if (user) {
            syncService.setUserId(user.uid)
            // Trigger initial queue processing
            syncService.processQueue()

            // Set up interval for periodic check? 
            // Or rely on repostiry calls to trigger processQueue?
            // Repository calls queueSync => we can trigger generic event or just let it sit until next process.
            // A simple interval is good for reliability.
            const interval = setInterval(() => {
                syncService.processQueue()
            }, 10000)

            return () => {
                clearInterval(interval)
                syncService.setUserId(null)
            }
        } else {
            syncService.setUserId(null)
        }
    }, [user])

    return <>{children}</>
}
